/**
 * @file Shared Markdown rendering helpers.
 */

import { marked } from "https://cdn.jsdelivr.net/npm/marked@18.0.3/lib/marked.esm.js";
import {
  sanitizeMarkdownPreviewHTML,
} from "./contentUtils.js";

/**
 * Renders Markdown text into sanitized HTML.
 * @param {string} markdownText Markdown content.
 * @param {object} [options] Markdown rendering options.
 * @param {boolean} [options.breaks=false] Whether single line breaks render as <br>.
 * @returns {string} Sanitized Markdown HTML.
 */
export function renderMarkdownToHtml(markdownText = "", options = {}) {
  const source = String(markdownText ?? "");
  if (!source.trim()) {return "";}

  const renderedHtml = marked.parse(source, {
    async: false,
    breaks: options.breaks === true,
    gfm: true,
  });
  return sanitizeMarkdownPreviewHTML(renderedHtml);
}
